export var THEME_DATA_ATTRIBUTE = 'data-theme';
export var COLOR_MODE_ATTRIBUTE = 'data-color-mode';
export var DEFAULT_THEME = 'light spacing';
export var CSS_PREFIX = 'ds';
export var CSS_VAR_FULL = ['opacity'];
export var TOKEN_NOT_FOUND_CSS_VAR = "--".concat(CSS_PREFIX, "-token-not-found");